import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	hiddenInConfiguration: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration',
		defaultMessage:
			'This field is hidden in the field configuration, and you can\'t see it in the issue view. <a>Go to "{configName}"</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	contextNotApplied: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied',
		defaultMessage:
			"You can't see this field in the issue view as the context is not applied to this project. <a>Go to context</a> to choose applicable context.",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
	contextNotAppliedNonGlobalAdmin: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-non-global-admin',
		defaultMessage:
			"You can't see this field in the issue view as the context is not applied to this project.",
		description:
			'Warning text for users who are not global admins when field context is set, when there is no context at all or the context is for different project',
	},
	contextNotAppliedV2: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-v2',
		defaultMessage:
			"You  can't see this field in the issue view as the context is not applied to this project. <a>Go to context</a> to choose applicable context or create a new one.",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
	restrictedFieldIconLabel: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.restricted-field-icon-label',
		defaultMessage: 'This field is restricted',
		description: 'Icon text indicating that the field is restricted',
	},
	hiddenInConfigurationForSingleIssueTypeNonGlobalAdmin: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-non-global-admin',
		defaultMessage:
			'This field is hidden for the “{issueTypeName}” issue type, and you can’t see it in the issue view.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForTwoIssueTypesNonGlobalAdmin: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-non-global-admin',
		defaultMessage:
			'This field is hidden for the “{issueTypeName1}” and “{issueTypeName2}” issue types, and you can’t see it in the issue view.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForNIssueTypesNonGlobalAdmin: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-non-global-admin',
		defaultMessage:
			'This field is hidden for {associatedIssueTypesCount, plural, one {# issue type} other {# issue types}}, and you can’t see it in the issue view.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForSingleIssueType: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type',
		defaultMessage:
			'This field is hidden for the “{issueTypeName}” issue type, and you can’t see it in the issue view. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForTwoIssueTypes: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types',
		defaultMessage:
			'This field is hidden for the “{issueTypeName1}” and “{issueTypeName2}” issue types, and you can’t see it in the issue view. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForNIssueTypes: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types',
		defaultMessage:
			'This field is hidden for {associatedIssueTypesCount, plural, one {# issue type} other {# issue types}}, and you can’t see it in the issue view. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-issue-term-refresh',
		defaultMessage:
			'This field is hidden in the field configuration, and you can\'t see it in the work item. <a>Go to "{configName}"</a> to change this."',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	contextNotAppliedIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-issue-term-refresh',
		defaultMessage:
			"You can't see this field in the work item as the context is not applied to this project. <a>Go to context</a> to choose applicable context.",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
	contextNotAppliedNonGlobalAdminIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-non-global-admin-issue-term-refresh',
		defaultMessage:
			"You can't see this field in the work item as the context is not applied to this project.",
		description:
			'Warning text for users who are not global admins when field context is set, when there is no context at all or the context is for different project',
	},
	contextNotAppliedV2IssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.context-not-applied-v2-issue-term-refresh',
		defaultMessage:
			"You can't see this field in the work item as the context is not applied to this project. <a>Go to context</a> to choose applicable context or create a new one.",
		description:
			'Warning text when field context is set, when there is no context at all or the context is for different project',
	},
	hiddenInConfigurationForSingleIssueTypeNonGlobalAdminIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-non-global-admin-issue-term-refresh',
		defaultMessage:
			'This field is hidden for the “{issueTypeName}” work type, and you can’t see it in the work item.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForTwoIssueTypesNonGlobalAdminIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-non-global-admin-issue-term-refresh',
		defaultMessage:
			'This field is hidden for the “{issueTypeName1}” and “{issueTypeName2}” work types, and you can’t see it in the work item.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForNIssueTypesNonGlobalAdminIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-non-global-admin-issue-term-refresh',
		defaultMessage:
			'This field is hidden for {associatedIssueTypesCount, plural, one {# work type} other {# work types}}, and you can’t see it in the work item.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForSingleIssueTypeIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-single-issue-type-issue-term-refresh',
		defaultMessage:
			'This field is hidden for the “{issueTypeName}” work type, and you can’t see it in the work item. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForTwoIssueTypesIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-two-issue-types-issue-term-refresh',
		defaultMessage:
			'This field is hidden for “{issueTypeName1}” and “{issueTypeName2}” work types, and you can’t see it in the work item. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
	hiddenInConfigurationForNIssueTypesIssueTermRefresh: {
		id: 'project-settings-apps-issue-type-page-product-features.restricted-field-warnings.hidden-in-configuration-for-n-issue-types-issue-term-refresh',
		defaultMessage:
			'This field is hidden for {associatedIssueTypesCount, plural, one {# work type} other {# work types}}, and you can’t see it in the work item. <a>Go to “{fieldConfigName}”</a> to change this.',
		description:
			'Warning text which appears when restricted field is expanded and the field is hidden in configuration',
	},
});
